export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "£0.00";
  return `£${parseFloat(value).toFixed(2)}`;
};
